import React from 'react';
import { Lock, Server, FileCheck } from 'lucide-react';

const complianceItems = [
  {
    icon: Lock,
    title: 'Proteção de Dados',
    desc: 'Criptografia AES-256 em repouso e TLS 1.3 em trânsito. Segregação de ambientes por unidade e departamento.',
  },
  {
    icon: Server,
    title: 'Disponibilidade & SLA',
    desc: '99,97% de uptime contratual. Failover Multi-AZ, backups incrementais e RTO < 4h para recuperação.',
  },
  {
    icon: FileCheck,
    title: 'Conformidade Regulatória',
    desc: 'LGPD, ISO/IEC 27001, SOC 2 Type II e trilha de auditoria imutável em todas as operações críticas.',
  },
];

const certifications = ['ISO 27001', 'SOC 2 Type II', 'LGPD', 'ISO 9001', 'GDPR Ready', 'PCI DSS', 'AES-256'];

export function SiteSecuritySection() {
  return (
    <section id="security" className="border-y border-slate-200/60 bg-slate-50/80 py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-10 text-center">
          <p className="mb-4 text-sm font-bold uppercase tracking-widest text-slate-500 md:text-base">
            Arquitetura & Conformidade
          </p>
          <h2 className="mx-auto max-w-4xl text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-4xl lg:text-5xl">
            Padrões de Segurança e Disponibilidade para o Mercado Corporativo.
          </h2>
        </div>

        <div className="mb-8 grid gap-4 md:grid-cols-3">
          {complianceItems.map((item) => {
            const Icon = item.icon;
            return (
              <div
                key={item.title}
                className="rounded-xl border border-slate-200/80 bg-white p-5 shadow-sm"
              >
                <div className="mb-3 w-fit rounded-lg bg-slate-100 p-2">
                  <Icon size={18} className="text-slate-600" />
                </div>
                <h3 className="mb-2 text-slate-900" style={{ fontWeight: 700, fontSize: '0.875rem' }}>
                  {item.title}
                </h3>
                <p className="leading-relaxed text-slate-600" style={{ fontSize: '0.8rem' }}>
                  {item.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="rounded-xl border border-slate-200/60 bg-white px-6 py-5 shadow-sm sm:px-8">
          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6">
            <span
              className="uppercase tracking-widest text-slate-400"
              style={{ fontSize: '0.65rem', fontWeight: 700 }}
            >
              Certificações & Conformidade
            </span>
            {certifications.map((cert) => (
              <span
                key={cert}
                className="flex items-center gap-1.5 rounded-md border border-slate-200 px-3 py-1 text-slate-600"
                style={{ fontSize: '0.775rem', fontWeight: 600 }}
              >
                <span className="h-1 w-1 rounded-full bg-slate-400" />
                {cert}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
